<template lang="html">
<div class="v-scope-home-modulo-comunicaciones">
<section class="modulos-comunicaciones" v-if="comunicaciones.length > 0">

    <h2 class="titulo">{{$t('comunicaciones.titulo')}}</h2>

    <div class="comunicaciones-list row-between" >
      
      <comunicacion-el v-for="(n,key) in comunicaciones" :data="n" :key="key"></comunicacion-el>
      
    </div>


  </section>
</div>
</template>

<script lang="js">

  import {mapGetters} from 'vuex';

  import comunicacionEl from './comunicacion-el'

  export default  {
    name: 'modulo-comunicaciones',
    components :{
      'comunicacion-el' : comunicacionEl
    },
    computed : {
      ...mapGetters({
        comunicaciones : 'getComunicaciones'
      }),
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/views/home/modulo-comunicaciones.vue